import React, { Suspense, lazy } from 'react';
import { useTheme } from './ThemeProvider';

// Lazy-loaded Theme 2 page components, keyed by logical page name.
// Add an entry here + pass the matching pageKey from App to theme a new page.
const T2_PAGES = {
  home: lazy(() => import('./theme2/Theme2Home')),
  about: lazy(() => import('./theme2/Theme2About')),
  services: lazy(() => import('./theme2/Theme2Services')),
  contact: lazy(() => import('./theme2/Theme2Contact')),
  products: lazy(() => import('./theme2/Theme2Products')),
  cart: lazy(() => import('./theme2/Theme2Cart')),
  wishlist: lazy(() => import('./theme2/Theme2Wishlist')),
  login: lazy(() => import('./theme2/Theme2Login')),
  register: lazy(() => import('./theme2/Theme2Register')),
  forgot: lazy(() => import('./theme2/Theme2ForgotPassword')),
  privacy: lazy(() => import('./theme2/Theme2PrivacyPolicy')),
  terms: lazy(() => import('./theme2/Theme2TermsConditions')),
  refund: lazy(() => import('./theme2/Theme2RefundPolicy')),
  quote: lazy(() => import('./theme2/Theme2Quote')),
};

/**
 * Renders the Theme 2 version of a page when Theme 2 is active and a redesign
 * exists, otherwise the original Theme 1 component (full functionality kept).
 */
const ThemedPage = ({ pageKey, fallback: Fallback }) => {
  const { isTheme2 } = useTheme();
  const T2 = T2_PAGES[pageKey];

  if (isTheme2 && T2) {
    return (
      <Suspense fallback={null}>
        <T2 />
      </Suspense>
    );
  }
  return <Fallback />;
};

export default ThemedPage;
